import React, { useMemo, useState } from "react";
import NavLight from "components/Nav/NavLight";
import Footer from "components/Footer";

const faqs = [
  {
    q: "What is OrderRun?",
    a: "OrderRun is an all-in-one business management platform designed specifically for sportswear manufacturers. It covers CRM, quotes, work orders, inventory, production, analytics, and more.",
  },
  {
    q: "Is there a free trial?",
    a: "Yes! We offer a free 30-day trial with no credit card required.",
  },
  {
    q: "Can I manage inventory and production?",
    a: "Absolutely. OrderRun provides real-time inventory tracking, purchase order management, and production control tools.",
  },
  {
    q: "Is my data secure?",
    a: "Yes. We use encrypted data storage, role-based access, and secure password management to keep your business safe.",
  },
  {
    q: "How do I get support?",
    a: "Our support team is available 24/7 via email and chat. You can also access our knowledge base for self-help resources.",
  },
  {
    q: "Can I export my data?",
    a: "Yes, you can export reports, inventory logs, and more in Excel-ready formats for audits and analysis.",
  },
];

function FAQsPage() {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    if (!query) return faqs;
    const q = query.toLowerCase().trim();
    return faqs.filter(
      (f) => f.q.toLowerCase().includes(q) || f.a.toLowerCase().includes(q),
    );
  }, [query]);

  return (
    <>
      <NavLight />

      <header
        className="py-5 text-white"
        style={{
          background: "linear-gradient(90deg,#0d6efd 0%, #6f42c1 100%)",
        }}
      >
        <div className="container text-center">
          <h1 className="display-5 fw-bold mb-2">
            <i className="mdi mdi-frequently-asked-questions me-2"></i>
            Help & FAQs
          </h1>
          <p className="lead text-white-50 mb-3">
            Quick answers to common questions about OrderRun.
          </p>
          <div className="mx-auto" style={{ maxWidth: 720 }}>
            <div className="input-group shadow-sm rounded-pill overflow-hidden">
              <span className="input-group-text bg-white border-0">
                <i className="mdi mdi-magnify text-muted"></i>
              </span>
              <input
                className="form-control form-control-lg border-0"
                placeholder="Search questions, e.g., trial, inventory, pricing..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
          </div>
        </div>
      </header>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-8">
              <div className="row g-1">
                {filtered.length === 0 && (
                  <div className="col-12">
                    <div className="alert alert-info">
                      No matching questions. Try a different keyword.
                    </div>
                  </div>
                )}

                {filtered.map((faq, idx) => (
                  <div className="col-12 mb-0 " key={faq.q}>
                    <div className="card shadow-sm border-0">
                      <div className="card-body">
                        <div className="d-flex align-items-start gap-3">
                          <div className="flex-shrink-0">
                            <div
                              className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: 48, height: 48 }}
                            >
                              <i className="mdi mdi-help-circle-outline"></i>
                            </div>
                          </div>
                          <div>
                            <h5 className="mb-1 fw-semibold">{faq.q}</h5>
                            <p className="mb-0 text-muted">{faq.a}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <aside className="col-lg-4">
              <div className="card shadow-sm border-0 mb-3">
                <div className="card-body">
                  <h6 className="fw-bold">Need more help?</h6>
                  <p className="text-muted">
                    Contact our support team for personalized assistance.
                  </p>
                  <a href="/contact-us" className="btn btn-primary btn-sm">
                    Contact Support
                  </a>
                </div>
              </div>

              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <h6 className="fw-bold">Popular topics</h6>
                  <ul className="list-unstyled mt-3">
                    <li className="mb-2">
                      <a href="#" className="text-decoration-none">
                        Free trial & activation
                      </a>
                    </li>
                    <li className="mb-2">
                      <a href="#" className="text-decoration-none">
                        Inventory & stock control
                      </a>
                    </li>
                    <li className="mb-2">
                      <a href="#" className="text-decoration-none">
                        Integrations
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        .card h5 { color: #0f1724; }
        header p { opacity: .95 }
        .input-group-text { border-radius: 0; }
        a.text-decoration-none:hover { text-decoration: underline; }
      `}</style>
    </>
  );
}

export default FAQsPage;
